import { getOrderFulfillmentCTA } from "./shared";
export var AddressAndPhoneNumber = function AddressAndPhoneNumber(strictLocalize) {
  return {
    titleBuilder: function titleBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getTitle();
    },
    descriptionBuilder: function descriptionBuilder() {
      return reimbursementOfShippingCostBuilder(strictLocalize).getDescription();
    },
    primaryCtaBuilder: {
      textBuilder: function textBuilder(context) {
        var _getOrderFulfillmentC;
        return (_getOrderFulfillmentC = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC === void 0 ? void 0 : _getOrderFulfillmentC.label;
      },
      linkBuilder: function linkBuilder(context) {
        var _getOrderFulfillmentC2, _getOrderFulfillmentC3;
        return (_getOrderFulfillmentC2 = getOrderFulfillmentCTA(context, strictLocalize)) === null || _getOrderFulfillmentC2 === void 0 ? void 0 : (_getOrderFulfillmentC3 = _getOrderFulfillmentC2.getLink) === null || _getOrderFulfillmentC3 === void 0 ? void 0 : _getOrderFulfillmentC3.call(_getOrderFulfillmentC2);
      }
    }
  };
};
var reimbursementOfShippingCostBuilder = function reimbursementOfShippingCostBuilder(strictLocalize) {
  return {
    getTitle: function getTitle() {
      return strictLocalize({
        id: "uNzg15",
        defaultMessage: [{
          "type": 0,
          "value": "Update the phone number on your order fulfilment page"
        }]
      });
    },
    getDescription: function getDescription() {
      return [strictLocalize({
        id: "1f8FkR",
        defaultMessage: [{
          "type": 0,
          "value": "Depending on your issue and the status of your shipment, you might be able to correct the address or phone number during order fulfilment. You can edit the order’s ship from address in \"Step 2. Ship from address\" of the order fulfilment page."
        }]
      }), strictLocalize({
        id: "xnaL/E",
        defaultMessage: [{
          "type": 0,
          "value": "Sometimes this can be a typo or there is a space where there shouldn’t be. If the retailer address is invalid, you can message or email the retailer directly by going to their customer page. If you’re still having issues, please contact us."
        }]
      })];
    }
  };
};